import { Link } from "wouter";
import { AppLayout } from "@/components/layout/AppLayout";
import {
  Building2,
  Briefcase,
  Users,
  Settings,
  ChevronRight,
  LogOut,
} from "lucide-react";
import { useAuth } from "@/lib/auth";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const menuItems = [
  { name: "Buyer Network", href: "/buyers", icon: Building2, description: "PE firms and strategic acquirers" },
  { name: "Clients", href: "/clients", icon: Briefcase, description: "M&A, capital raises, and engagements" },
  { name: "COI", href: "/coi", icon: Users, description: "Centers of Influence" },
  { name: "Settings", href: "/settings", icon: Settings, description: "Account preferences" },
];

export default function More() {
  const { user, logout } = useAuth();

  return (
    <AppLayout title="More">
      <div className="max-w-lg mx-auto space-y-6">
        <div className="bg-card rounded-xl border border-border p-4 flex items-center gap-4">
          <Avatar className="w-14 h-14 ring-2 ring-primary/20">
            <AvatarImage src={user?.profileImageUrl || ""} />
            <AvatarFallback className="bg-primary text-primary-foreground font-semibold">{user?.initials || "?"}</AvatarFallback>
          </Avatar>
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-foreground truncate">{user?.name || "User"}</p>
            <p className="text-sm text-muted-foreground truncate">{user?.email || ""}</p>
          </div>
        </div>

        <div className="bg-card rounded-xl border border-border overflow-hidden">
          {menuItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.name}
                href={item.href}
                className={`flex items-center gap-4 p-4 touch-manipulation active:bg-muted/50 transition-colors ${
                  index !== menuItems.length - 1 ? "border-b border-border" : ""
                }`}
                data-testid={`more-${item.name.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <div className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center flex-shrink-0">
                  <Icon className="w-5 h-5 text-foreground" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-foreground">{item.name}</p>
                  <p className="text-sm text-muted-foreground truncate">{item.description}</p>
                </div>
                <ChevronRight className="w-5 h-5 text-muted-foreground flex-shrink-0" />
              </Link>
            );
          })}
        </div>

        <button
          onClick={() => logout()}
          className="w-full bg-card rounded-xl border border-border p-4 flex items-center gap-4 touch-manipulation active:bg-muted/50 transition-colors text-left"
          data-testid="more-logout"
        >
          <div className="w-10 h-10 rounded-lg bg-destructive/10 flex items-center justify-center flex-shrink-0">
            <LogOut className="w-5 h-5 text-destructive" />
          </div>
          <div className="flex-1">
            <p className="font-medium text-destructive">Log Out</p>
          </div>
        </button>
      </div>
    </AppLayout>
  );
}
